import { render, staticRenderFns } from "./WappTemplateMessage.vue?vue&type=template&id=1727cff3"
import script from "./WappTemplateMessage.vue?vue&type=script&lang=js"
export * from "./WappTemplateMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports